export default function Logo({ size = 32, className = "" }) {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 48 48" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="makarioGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#5b4bff', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#8174ff', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <path 
        d="M8 38V10L24 26L40 10V38H34V20L24 30L14 20V38H8Z" 
        fill="url(#makarioGradient)"
      />
    </svg>
  );
}
